import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Form, Col, Button, Row } from "react-bootstrap";
import emailjs from "@emailjs/browser"; // Ensure this is installed via npm

export default function SendEmailForm({ env }) {
    const formRef = useRef(null);
    const initialData = {
        cli_name: "",
        company_name: "",
        email: "",
        contact_num: "",
        message: ""
    }
  const [formData, setFormData] = useState(initialData);

  const [formEmailSent, setFormEmailSent] = useState(null);
    const [formEmailSentError, setFormEmailSentError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCancel = () => {
    setFormData(initialData);
    setFormEmailSent(null);
    setFormEmailSentError(null);
  };

    const handleSubmit = (event) => {
        event.preventDefault();

        const {
            REACT_APP_EMAILJS_TEMPLATEID: templateId,
            REACT_APP_EMAILJS_SERVICEID: serviceId,
            REACT_APP_EMAILJS_PUBLICKEY: publicKey,
        } = env;

        console.log(templateId, serviceId, publicKey);
        emailjs.sendForm(
            serviceId,
            templateId,
            formRef.current,
            publicKey
        )
            .then((res) => {
                if (res.status === 200) {
                console.log(res);
                    setFormEmailSent("Message sent successfully!");
                    setFormEmailSentError(null);
                    setFormData(initialData);
                } else {
                    setFormEmailSentError("Faled to send email. Please try again.");
                    setFormEmailSentError(null);
                }
            })
            .catch(err => {
                console.error("Failed to send email. Error:", err);
                setFormEmailSentError("Failed to send email. Error:", err);
            });
    };

  return (
      <Form className="feedback-form" onSubmit={handleSubmit} onAbort={handleCancel} ref={formRef}>
        <Row className="col-lg-16 frm-row">
          <Col xs={6}>
            <Form.Control
                size="lg"
                type="text"
                placeholder="Enter your name"
                name="cli_name"
                value={formData?.cli_name}
                onChange={handleChange}
            />
          </Col>
          <Col xs={6}>
            <Form.Control
                size="lg"
                type="text"
                placeholder="Enter your company name"
                name="company_name"
                value={formData?.company_name}
                onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="col-lg-16 frm-row">
          <Col xs={6}>
            <Form.Control
                size="lg"
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData?.email}
                onChange={handleChange}
            />
          </Col>
          <Col xs={6}>
            <Form.Control
                size="lg"
                type="text"
                placeholder="Enter your contact number"
                name="contact_num"
                value={formData?.contact_num}
                onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="col-lg-16 frm-row">
          <Col xs={12}>
            <Form.Control
                size="lg"
                as="textarea"
                placeholder="Enter your message"
                rows="10"
                name="message"
                value={formData?.message}
                onChange={handleChange}
            />
          </Col>
        </Row>
          {formEmailSent && (
              <h5 className="text-success mt-3">{formEmailSent}</h5>
          )}
          {formEmailSentError && (
              <h5 className="text-success mt-3">{formEmailSentError}</h5>
          )}
        <Row className="col-lg-16 frm-row">
          <Col xs={12}>
            <Button
                variant="danger"
                className="float-right"
                onClick={handleCancel}
            >
              CANCEL
            </Button>
            <Button
                variant="success"
                className="float-right"
                style={{ marginRight: "10px" }}
                type="submit"
            >
              SEND MESSAGE
            </Button>
          </Col>
        </Row>


      </Form>
  );
}

SendEmailForm.propTypes = {
  env: PropTypes.object.isRequired
};
